import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import "./style.css";
import dtLogo from "./img/main-title.svg";
import reportIcon from "./img/report-icon.svg";
import checkIcon from "./img/check-icon.svg";
import infoIcon from "./img/info-icon.svg";

class Collapsible extends React.Component {
  constructor(props) {
    super(props);

    this.togglePanel = this.togglePanel.bind(this);
  }

  togglePanel(e) {
    this.props.onHeaderClick && this.props.onHeaderClick(e);
  }

  componentDidUpdate() {}

  render() {
    return (
      <div className="collapsible">
        <div>
             {this.props.open ? (
                       <div className="reportContent">{this.props.children}</div>
                     ) : null}

             <div onClick={(e) => this.togglePanel(e)} className={this.props.open ? "title-selected" : "title"}>
                 {this.props.title}
         </div>
        </div>
      </div>
    );
  }
}

class TitleComponent extends React.Component {
  render() {
    return (
    <div>
    {this.props.isShown && (
    <div className="title-component">
            <img src={this.props.icon} alt="Component logo" />
            <div className="title-component-title">{this.props.title}</div>
          </div>

    )}
    </div>
    );
  }
}

class MultiChoice extends React.Component {
  constructor(props) {
    super(props);
    this.state = { selectedCheckBox: {} };
  }

  onCheckBoxClicked(item, index) {
    this.setState({ selectedCheckBox: item });
    this.props.onSelectedItem && this.props.onSelectedItem(item);
  }

  render() {
    const { choices } = this.props;
    const { selectedCheckBox } = this.state;
    const fn = this.onCheckBoxClicked.bind(this);
    const childs = choices.map(function (item, index) {
      const selected = selectedCheckBox.title === item.title; // might be better to compare index. but ok
      return (
        <div key={item.title} className={`check-box-1`} onClick={(e) => fn(item, index)}>
          <div
            className={selected ? "check-box-selected" : "check-box-empty-1"}
          />
          <div className="cb-title">{item.title}</div>
        </div>
      );
    });

    return <div>{childs}</div>;
  }
}

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapseOpen: "none",
      isLoading: false,
      sentReport: false,
      selectedChoice: "",
      urlParamsState: undefined,
      otherInputClicked: false

    };
    this.reportAdRef = React.createRef();
  }

   isElementVisibleInParent (el) {

       if (!el || !(el instanceof Element)) {
           return false;
       }

       var rect = el.getBoundingClientRect();
       var parent = el.parentElement;

       if (!parent) {
           return false;
       }

       var parentRect = parent.getBoundingClientRect();
       return (
           rect.top >= parentRect.top &&
           rect.left >= parentRect.left &&
           rect.bottom <= parentRect.bottom &&
           rect.right <= parentRect.right
       );
  }

  focusSuccessMessage() {
    const sendReportThxTitleStyle = document.getElementById("sendReportThxTitleStyle");
      if (!this.isElementVisibleInParent(sendReportThxTitleStyle)) {
        const scrollableDiv = document.getElementById("scrollable-div");
        if (scrollableDiv) {
            scrollableDiv.scrollTop = scrollableDiv.scrollHeight;
        }
     }
  }

  componentDidMount() {
    this.extractUrlParameters();
    window.reportSent = function () {
      this.setState({ isLoading: false, sentReport: true });
      this.focusSuccessMessage();
    }.bind(this);
  }

  extractUrlParameters() {
    const urlParams = new URLSearchParams(decodeURIComponent(window.location.search));
    const advertiser_domain = urlParams.get('advertiser_domain');
    const dsp_name = urlParams.get('dsp_name');
    const dsp_id = urlParams.get('dsp_id');

    if(advertiser_domain && dsp_name && dsp_id) {
     this.setState({urlParamsState: {
            adDomain: advertiser_domain,
            adNetwork: dsp_name,
            adNetworkId: dsp_id
        }});
    }
  }

  sendReportText() {
    this.setState({ isLoading: true });
    const ifr = document.createElement("iframe");
    const container = document.body || document.documentElement;
    container.appendChild(ifr);
    ifr.setAttribute(
      "style",
      "position: fixed; bottom: -20px; border: none; display: none; height: 20px; z-index: -99999"
    );

    let call = "fyberMarketplace://reportAd?";

    let text = "";
    if(this.reportAdRef.current != null) {
        text = this.reportAdRef.current.value;
        this.reportAdRef.current.blur();
    }
    if (text == null || text === "") {
      text = this.state.selectedChoice;
    }

    call += "=" + encodeURIComponent(text);

    ifr && ifr.setAttribute("src", call);
  }

  render() {
    const { isLoading, sentReport, urlParamsState, collapseOpen, otherInputClicked, selectedChoice } = this.state;
    return (
      <div className="fullscreenContainer">
       {(collapseOpen === "one" && !sentReport) && (
               <div className="overlay"
               onClick={() =>
                    this.setState({
                        collapseOpen: "none",
                        selectedChoice: ""
                    })
                  }/>
              )}

        <header>
          <div className="top-band"></div>
        </header>
        <main >
        <div className="container">
          <div id="scrollable-div">
        <img className="dt-logo" src={dtLogo} alt="DT logo" />
          <h2>Why Did I Get This Ad?</h2>
          <p>This ad contains content and commercial communication by the advertiser.</p>
          <p>You received this ad based on information collected from your mobile device, such as:</p>
            <ul>
              <li>
                <span>Your device Advertising ID, device make and model, operation system, screen size, device orientation, volume, battery, and disk space.</span>
              </li>
              <li>
                <span>Your device location: country, region, timezone, and IP Address.</span>
                </li>
              <li>
              <span>The mobile application you have been using when the ad was delivered: application name, version, mobile application store listing, and category.</span>
              </li>
            </ul>

           {urlParamsState &&  (

                <div class="aboutThisAdvertiserContainer">
                  <div class="header">
                       <img src={infoIcon} alt="About icon"/>
                    </div>

                  <div class="details">
                  <h5>About this advertiser:</h5>
                    <h6>Advertiser domain:</h6>
                    <p>{urlParamsState.adDomain}</p>
                    <h6>DSP Name:</h6>
                    <p>{urlParamsState.adNetwork}</p>
                  </div>
                </div>

           )}

           {sentReport && (
               <div id="sendReportThxTitleStyle">
                 <div className="checkIconDiv">
                   <img src={checkIcon} alt="Check icon"/>
                 </div>
                 <p className="Your-submission-was">
                   Your submission was received.
                   <br /> Thank you for reporting this ad.
                 </p>
               </div>
             )}
        </div>
            <Collapsible
                 open={this.state.collapseOpen === "one"}
                 onHeaderClick={() =>
                     this.setState({
                         collapseOpen: this.state.collapseOpen === "one" ? "none" : "one",
                         otherInputClicked: false
                     })
                 }
                 title={
                 <TitleComponent
                    icon={reportIcon}
                    title="Report an issue with this Ad"
                    isShown = {!sentReport}
                    />
                 }>
                 <div className="divReport">
                    {!sentReport && (
                    <div className="reportDiv">
                       <p className="reportTitle">Report this Ad:</p>
                       <div className="multi-choice-field">
                          <MultiChoice
                             onSelectedItem={(e) =>
                          {
                          this.setState({ selectedChoice: e.title,
                                        otherInputClicked: e.title === "Other"});

                          }}
                          choices={[
                          { title: "Video problem" },
                          { title: "Audio problem" },
                          { title: "Click problem" },
                          { title: "Offensive ad" },
                          { title: "Other" },
                          ]}
                          />
                          {otherInputClicked && (<div className="otherInput">
                                                <p className="otherDescription">Describe why you are creating this report</p>
                                                  <textarea
                                                     ref={this.reportAdRef}
                                                     id="reportAdInputText"
                                                     className="other-text-input"
                                                     />
                                               </div>)}

                       </div>
                       <div
                          onClick={this.sendReportText.bind(this)}
                          className={(selectedChoice !== "") ? "submitBtn" : "submitBtn-disabled"}>
                          <p className={(selectedChoice !== "") ? "submitBtnText" : "submitBtnDisabledText"}>Submit report</p>
                       </div>
                       <p className="clickableText" onClick={() =>
                                                             this.setState({
                                                                 collapseOpen: "none",
                                                                 selectedChoice: ""
                                                             })
                       }>Cancel</p>
                    </div>
                    )}
                 </div>
            </Collapsible>
        </div>

        </main>

      </div>
    );
  }
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();

